import { createContextPart } from "../create-context-part.js";
import { useSliderContext } from "./context.js";
//#region src/ui/slider/fill.tsx
/** Displays the filled portion from start to the current value. */
const SliderFill = createContextPart({
	displayName: "SliderFill",
	tag: "div",
	useContext: useSliderContext
});
//#endregion
export { SliderFill };

//# sourceMappingURL=fill.js.map